import getFeaturesForCaregiverGraph from './getFeaturesForCaregiverGraph';

export default {
  getFeaturesForCaregiver: getFeaturesForCaregiverGraph,
};
